export default "__VITE_ASSET__49f02f3d__"